import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pages: [],
  pageBuilderContent: [],
  pageFilters: [],
};

const adminPageSlice = createSlice({
  name: "pagebuilder",
  initialState,
  reducers: {
    setAdminPages: (state, action) => {
      state.pages = action.payload;
    },

    setPageFilter: (state, action) => {
      state.pageFilters = action.payload;
    },
  },
});

export const {
  setAdminPages,
  upsertPageBuilderSection,
  setPageFilter,
  removePageBuilderSection,
  removePageBuilderSectionRecord,
  resetPageBuilderContent,
} = adminPageSlice.actions;

export default adminPageSlice.reducer;
